import { useEffect } from 'react';
import ScaffoldPage from '../_ScaffoldPage';
export default function MonteCarloPage() {
  useEffect(() => { document.title = 'Monte Carlo Simulation — Probabilistic Portfolio Forecasting | Nuvport OS'; }, []);
  return <ScaffoldPage badge="MONTE CARLO" title="Run 10,000 simulations of your portfolio's future." description="Understand the full probability distribution of your returns. See best case, worst case, and median outcomes over 10 years with Monte Carlo simulation." canonical="/features/monte-carlo-simulation" />;
}
